import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiHome, FiCalendar, FiGrid, FiUsers, FiTrendingUp, FiStar, FiMessageSquare, FiBarChart3, FiSettings, FiShield } = FiIcons;

const Navigation = () => {
  const location = useLocation();
  
  const navItems = [
    { path: '/dashboard', icon: FiHome, label: 'Dashboard', subtitle: 'Your business at a glance' },
    { path: '/bookings', icon: FiCalendar, label: 'Bookings', subtitle: 'See and manage appointments' },
    { path: '/services', icon: FiGrid, label: 'Services', subtitle: 'Track and edit offerings' },
    { path: '/crm', icon: FiUsers, label: 'CRM', subtitle: 'Client relationships' },
    { path: '/marketing', icon: FiTrendingUp, label: 'Marketing', subtitle: 'Grow your visibility' },
    { path: '/trust-reviews', icon: FiStar, label: 'Trust & Reviews', subtitle: 'Your reputation' },
    { path: '/messages', icon: FiMessageSquare, label: 'Messages', subtitle: 'Talk to leads & clients' },
    { path: '/insights', icon: FiBarChart3, label: 'Insights', subtitle: 'Business analytics' },
    { path: '/settings', icon: FiSettings, label: 'Settings', subtitle: 'Manage preferences' },
  ];

  return (
    <nav className="fixed left-0 top-0 h-full w-64 bg-white shadow-lg border-r border-slate-200 z-50">
      <div className="p-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 bg-gradient-to-br from-trust-500 to-trust-600 rounded-lg flex items-center justify-center">
            <SafeIcon icon={FiShield} className="text-white text-xl" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-slate-800">TrustNation</h1>
            <p className="text-sm text-slate-500">Client Portal</p>
          </div>
        </div>

        <div className="space-y-2">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`block relative group ${isActive ? 'text-trust-600' : 'text-slate-600 hover:text-trust-600'}`}
              >
                <motion.div
                  className={`flex items-center gap-3 p-3 rounded-lg transition-all duration-200 ${
                    isActive 
                      ? 'bg-trust-50 text-trust-600 border border-trust-200' 
                      : 'hover:bg-slate-50 hover:text-trust-600'
                  }`}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <SafeIcon 
                    icon={item.icon} 
                    className={`text-lg ${isActive ? 'text-trust-600' : 'text-slate-500 group-hover:text-trust-600'}`} 
                  />
                  <div className="flex-1 min-w-0">
                    <div className={`font-medium ${isActive ? 'text-trust-600' : 'text-slate-700'}`}>
                      {item.label}
                    </div>
                    <div className="text-xs text-slate-500 truncate">
                      {item.subtitle}
                    </div>
                  </div>
                </motion.div>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;